/***
 *
 * @file components/Form/action.ts
 * @description Form actions used for submiting emails
 * @author Naveen Kumar
 * @organization Ingka Centres
 * @since 28 Mar 2024
 *
 */

import { EMSE } from "@/config/app.config";
import { flattenJson, getKeyFromPath, parseTemplate } from "@/helpers/api.helper";

// import { EMAIL_SECRET } from "@/config/app.config";

// const jwt = require('jsonwebtoken');
const emailSecret = EMSE


// // Handle email to send the user response
// export const sendEmail = async (emailBody: any) => {

//     try{
//         const res = await fetch('/api/auth', {
//             method: 'POST',
//             headers: {
//                 'Accept': 'application/json, text/plain, */*',
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({secret: emailSecret})
//         })

//         const data = await res.json();
//         if(!res.ok){
//             throw new Error("An error occured ")
//         } else {                
//             return fetch('/api/email', {
//                 method: 'POST',
//                 headers: {
//                     'Accept': 'application/json, text/plain, */*',
//                     'Content-Type': 'application/json',
//                     'Client-Token': data?.token
//                 },
//                 body: JSON.stringify(emailBody)
//             })
//             .then((res) => {
//                 console.log("Email sent ", res.status, res)
//                 // if(res?.error)
//                 if (res.status === 200) {
//                     console.log("Email sent")
//                 }
//             }).catch(error => console.log("api error ---- ==== ---- ", error)) 

//         }
//     }catch(err) {
//         console.log(err,"Error occured")
//     }
// }

export const sendEmail = async (emailBody: any) => {
    try {
        // Step 1: Fetch the authentication token from /api/auth
        const authRes = await fetch('/api/auth', {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ secret: emailSecret })
        });

        // Check if the authentication response is OK
        if (!authRes.ok) {
            throw new Error("Failed to authenticate. Please check the credentials.");
        }

        const authData = await authRes.json();

        // Step 2: Send email using the token from authentication
        const emailRes = await fetch('/api/email', {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'Client-Token': authData?.token
            },
            body: JSON.stringify(emailBody)
        });

        // Check if the email response is OK
        if (emailRes.ok) {
            console.log("Email sent successfully", emailRes.status);
        } else {
            console.log("Failed to send email", emailRes.status);
            const errorData = await emailRes.json();
            console.error("Error details:", errorData);
        }

        return await emailRes.json(); // return the response from email API
    } catch (err) {
        console.error("Error occurred during the email process:", err);
        throw new Error("An error occurred while sending the email.");
    }
};

export const submitForm = async ({ emailBody, messages }: { emailBody: any, messages: any }) => {
    try {
        const res = await fetch('/api/auth', {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ secret: emailSecret })
        })

        const data = await res.json();
        if (!res.ok) {
            throw new Error(messages?.error?.[emailBody?.language] || "An error has occured.")
        } else {
            console.log(emailBody, "testing body element", messages);
            return await fetch('/api/submit', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'Client-Token': data?.token
                },
                body: JSON.stringify(emailBody)
            }).then(async (res) => {
                const aaa: any = await res.json();
                const routeResolvedMessage = aaa?.resolvedMessage?.text || aaa?.resolvedMessage;
                // const flatResp = await flattenJson(aaa.apiResp);
                const flatResp = { ...(await flattenJson(aaa.apiResp)), ...(await flattenJson(aaa?.queryParams)), ...(await flattenJson(aaa?.payload)) };
                // console.log("form.action ----- submitForm flatResp: ", flatResp)
                console.log("form.action 1 ----- submitForm res: ", res)
                console.log("form.action 2 ----- submitForm aaa: ", aaa, flatResp);

                const receivedCode = Object?.keys(messages)?.includes(res?.status?.toString()) ? res.status : (res?.status?.toString()?.startsWith("2") ? 200 : 400);
                const language = Object?.keys(messages?.[receivedCode])?.includes(emailBody?.language) ? emailBody?.language : Object?.keys(messages?.[receivedCode])?.[0] || "en";
                const msg = messages?.[receivedCode]?.[language];
                console.log(
                    "form.action 3 ----- submitForm body: ",
                    res?.status,
                    emailBody?.language,
                    messages,
                    messages?.[res?.status],
                    messages?.[res?.status]?.[emailBody?.language],
                    messages?.[res?.status]?.[emailBody?.language]?.body,
                    messages?.[receivedCode],
                    messages?.[receivedCode]?.[language],
                    messages?.[receivedCode]?.[language]?.body
                )
                // debugger;
                // console.log("templateStr------",aaa?.successCodes, res?.status, { ...(msg)}, flatResp, 200 === res?.status, aaa?.successCodes?.includes(res?.status));

                if (200 === res?.status || aaa?.successCodes?.includes(res?.status) || aaa?.resolvedMessage?.messageType === "success") {
                    const successMessageBody = routeResolvedMessage || msg?.body || msg || "Thank you.";
                    // console.log(successMessageBody, "checking me");
                    const templateStr: string = typeof successMessageBody === "string"
                        ? successMessageBody
                        : (successMessageBody?.body ?? "");
                    // const aaa: any = await res.clone().json();
                    // const flatResp = await flattenJson(aaa.apiResp);
                    // console.log("form.action ----- submitForm: ", flatResp, messages?.[res.status]?.[language].title, messages?.[res.status]?.[language].body)

                    //  Check if the parser is to extract value of a path or a key from the path. [[prefix, regex, suffix]] = [["json.data", "/d+/g", "response_message"]]
                    let msgBody = "";
                    msgBody = getKeyFromPath(templateStr, flatResp);
                    // console.log("templateStr------1", msgBody);

                    msgBody = await parseTemplate(msgBody, flatResp);
                    // console.log("templateStr------2", msgBody);

                    return {
                        ok: true,
                        message: typeof routeResolvedMessage === "string"
                          ? { ...(msg || {}), body: msgBody || routeResolvedMessage }
                          : { ...(msg || {}), body: msgBody || "" },
                        expTmp: templateStr,
                        expResp: flatResp,
                        resolvedMessage: aaa?.resolvedMessage,
                        extractedResponseData: aaa?.extractedResponseData
                    } // || "Submitted successfully!" };
                } else if (res.status === 409) {
                    // throw new Error(JSON.stringify({error: "conflict", message: "Unable to subscribe!"}));
                    // console.log("Conflict email error ----- ", error);
                    throw new Error("bpError--" + (typeof routeResolvedMessage === "string" ? routeResolvedMessage : (msg?.body || "Unable to subscribe!")), { cause: res?.status });
                } else {
                    // throw new Error(JSON.stringify({message: "Unable to subscribe!"}));
                    // console.log("Other email error ----- ", error);
                    throw new Error("bpError--others--" + (typeof routeResolvedMessage === "string" ? routeResolvedMessage : (msg?.body || "Try again after some time.")), { cause: res?.status });
                }
            }).catch((error: any) => {
                const status = (error?.cause && Object?.keys(messages)?.includes(error?.cause)) ? error?.cause : "error";
                console.log("form.action error ----- ", { error, message: messages?.[status], language: emailBody?.language })
                // debugger
                const language = Object?.keys(messages?.[status])?.includes(emailBody?.language) ? emailBody?.language : Object?.keys(messages?.[status])?.[0] || "en";
                // debugger;
                // const err = JSON.parse(error);
                // debugger
                console.log("email error ----- ", error, error?.status, error?.message);
                if (error?.message?.includes("bpError--others--")) {
                    return { error: error?.message?.split("bpError--others--")?.[1] }
                } else if (error?.message?.includes("bpError--")) {
                    return { error: error?.message?.split("bpError--")?.[1] }
                } else {
                    const err = messages?.[status]?.[language]?.body || messages?.[status]?.[language] || "Try again after some time.";
                    return { error: { message: err, statusCode: status } };
                }
            })
        }
    } catch (error: any) {
        console.log(error, "Error occured")
        return { error }
        // if(error?.includes("bpError--")) {
        //     return { error: error?.split("bpError--")?.[1] }
        // } else {
        //     return { error: messages?.[400]?.[language] || "Try again after some time." };
        // }
    }
}